import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';

const Interchapter = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const [interchapter, setInterchapter] = useState([]);
  const [pendingList, setPendingList] = useState([]);
  const [completedList, setCompletedList] = useState([]);

  const pendingRef   = useRef(null);
  const completedRef = useRef(null);

  const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
  const [chapterId, setChapterId] = useState(initialChapter);  // for use in fetch

  const fetchInterchapter = async () => {
    try {
      const token = sessionStorage.getItem("token");
      let url = `${baseurl}/admin/interchapter`;

      if (roleid !== 1) {
        url += `?chapter_id=${chapterId}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setInterchapter(data);

      // pending → still actionable; anything else (approved/rejected/etc.) → completed
      setPendingList(data.filter(row => row.status === 'pending'));
      setCompletedList(data.filter(row => row.status !== 'pending'));
    } catch (error) {
      console.error('Error fetching interchapter:', error);
    }
  };


  useEffect(() => {
    fetchInterchapter();
  }, []);

  // ── Shared column/button config so both tables render identically ────────
  const buildColumns = () => ([
    { data: null, title: "Sr.No", className: "text-center" },
    { data: 'membership_no', title: 'Membership No' },
    { data: 'from_chapter_id', title: 'Chapter ID' },
    {
      data: null,
      title: 'Member Name',
      render: function (data, type, row) {
        return (row.first_name || '') + ' ' + (row.last_name || '');
      }
    },
    { data: 'mobile_no', title: 'Mobile No' },
    { data: 'email', title: 'Email' },
    { data: 'from_chapter_name', title: 'From Chapter', className: "text-center" },
    { data: 'to_chapter_name', title: 'To Chapter', className: "text-center" },
    { data: 'reason', title: 'Reason' },
    { data: null, title: 'Action', orderable: false },
  ]);

  const buildColumnDefs = (withActions) => ([
    {
      targets: 0,
      render: (data, type, row, meta) => meta.row + 1,
    },
    {
      targets: 1,
      render: (data, type, row) => {
        if (type !== 'display') return data ?? '';
        const mid = row.member_id ?? row.from_member_id ?? row.memberId ?? '';
        return `<center><a href="/admin/EditMember?memberId=${mid}&edit=false" onclick="event.preventDefault(); window.open(this.href, '_blank');">${data ?? ''}</a></center>`;
      },
    },
    {
      targets: 9,
      render: (data, type, row) => {
        if (withActions && row.status === 'pending') {
          return `<select class="form-select form-select-sm transfer-action-dd" data-id="${row.id}" style="min-width:130px">
                    <option value="">Select</option>
                    <option value="approved">Approve</option>
                    <option value="rejected">Reject</option>
                  </select>`;
        }
        return `<span class="badge bg-secondary">${row.status}</span>`;
      },
    },
  ]);

  const renderTable = (tableElement, tableData, withActions) => {
    if (!tableElement) return;

    if ($.fn.DataTable.isDataTable(tableElement)) {
      const table = $(tableElement).DataTable();
      table.clear();
      table.rows.add(tableData);
      table.draw();
      return;
    }

    $(tableElement).DataTable({
      dom: 'Blfrtip',
      pageLength: 25,
      lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
      buttons: [
        { extend: 'copyHtml5',  className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'excelHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'csvHtml5',   className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'pdfHtml5',   className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'print',      className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
      ],
      data: tableData,
      columns: buildColumns(),
      columnDefs: buildColumnDefs(withActions),
      initComplete: function () {
        $('.dt-length select').addClass('form-select form-select-sm');
      }
    });
  };

  useEffect(() => {
    renderTable(pendingRef.current,   pendingList,   true);
    renderTable(completedRef.current, completedList, false);

    $(document).off('change', '.transfer-action-dd').on('change', '.transfer-action-dd', async function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      const status = $(this).val();
      const $dd = $(this);
      if (!status) return;

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: `Do you want to ${status.toLowerCase()} this member transfer?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes, ${status}!`,
        cancelButtonText: 'Cancel',
      });

      if (!result.isConfirmed) { $dd.val(''); return; }
      if (result.isConfirmed) {
        try {
          const token = sessionStorage.getItem("token");
          await $.ajax({
            url: `${baseurl}/admin/interchapter/${id}`,
            type: 'PUT',
            headers: {
              Authorization: `${token}`,
              'Content-Type': 'application/json',
            },
            data: JSON.stringify({ status }), // send status in body
          });

          Swal.fire(
            `${status}!`,
            `Member transfer ${status.toLowerCase()} successfully.`,
            'success'
          );

          fetchInterchapter(); // refresh both tables
        } catch (error) {
          console.error(`Error updating status to ${status}:`, error);
          Swal.fire('Error', `Error while updating status.`, 'error');
        }
      }
    });

    return () => {
      if (pendingRef.current && $.fn.DataTable.isDataTable(pendingRef.current)) {
        $(pendingRef.current).DataTable().destroy();
      }
      if (completedRef.current && $.fn.DataTable.isDataTable(completedRef.current)) {
        $(completedRef.current).DataTable().destroy();
      }
    };
  }, [pendingList, completedList]);

  return (
    <div className="content container-fluid">
      <center><h1>Interchapter List</h1></center>

      <div className="container mt-4">
        <div className="profile-section">
          <div className="list mb-4" style={{ overflow: "auto" }}>
            <div className="row">
              <center><h4><b>Pending Interchapter</b></h4></center>
              <div className="col-12">
                <table ref={pendingRef} className="table table-striped table-bordered" style={{ width: '100%' }}></table>
              </div>
            </div>
          </div>

          <div className="list" style={{ overflow: "auto" }}>
            <div className="row">
              <center><h4><b>Completed Interchapter</b></h4></center>
              <div className="col-12">
                <table ref={completedRef} className="table table-striped table-bordered" style={{ width: '100%' }}></table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Interchapter;